export default "__VITE_ASSET__Caknictd__"